import { SystemLogFilterWithoutSetter } from './types'

export const EM360_DEFAULT_MODBUS_SETTINGS = {
  modbusEnabled: false,
  modbusProtocol: 'e3dc' as const,
  modbusPort: 502,
  useCT: false,
  ratioCT: '400:5',
}

export const EM360_DEFAULT_CHARGING_STRATEGY = {
  emsBatteryBeforeCarMode: false,
  emsWeatherRegulatedChargeEnabled: false,
}

export const EM360_DEFAULT_LIMIT_POWER_SETTINGS = {
  powerLimitsUsed: false,
  emsMaxChargePower: 0,
  emsMaxDischargePower: 0,
  frequencyReverseProtectionLower: 0,
}

export const NOT_PARSABLE_SYSTEM_LOG_FILTERS: (keyof SystemLogFilterWithoutSetter)[] = ['sortFilter']

export const NEW_INSTALLATIONS_PATH = '/installer-dashboard/new-installations'

export const REQUIRE_ATTENTION_INSTALLATIONS_PATH = '/installer-dashboard/warning'

export const INSTALLATION_SEARCH_PATH = '/installer-dashboard/search'

export const MISSING_IBN_PATH = '/installer-dashboard/missing-ibn'

export const NO_ACCESS_PATH = '/installer-dashboard/no-access'

export const PLANNED_INSTALLATIONS = '/installer-dashboard/planned-installations'

export const INSTALLER_DASHBOARD_PATH = '/installer-dashboard'

export const INSTALLER_DAHBOARD_PATHS_TABS_MAPPER = [
  INSTALLATION_SEARCH_PATH,
  NEW_INSTALLATIONS_PATH,
  REQUIRE_ATTENTION_INSTALLATIONS_PATH,
  MISSING_IBN_PATH,
  NO_ACCESS_PATH,
]

export const CACHE_TIME = 60 * 60 * 1000 /* valid time for installation information cached by React Query */

/* Number of months before the installation statement deadline to trigger a warning. */
export const INSTALLATION_STATEMENT_DEADLINE_THRESHOLD_MONTHS = 6
